import { api } from './api';
import type { GscCallbackResult, GscImportResponse, GscStatus } from '@traaker/shared';

/**
 * Google Search Console (Prompt Studio lot H). The OAuth callback is an
 * AUTHENTICATED POST from the SPA page Google redirects to, so the grant is bound
 * to the logged-in user (H-search-console.md step 7). Never log `code` / `state`.
 */
export const searchConsoleApi = {
  /** `candidates`: also list the account's properties (one Google call: « Changer » only). */
  status: (brandId: string, opts?: { candidates?: boolean }) =>
    api.get<GscStatus>(`/brands/${brandId}/search-console${opts?.candidates ? '?candidates=1' : ''}`),

  /** `returnPath` is a path (optionally with its own query); the API replaces anything else by `/`. */
  authorize: (brandId: string, returnPath: string) =>
    api.post<{ url: string }>(`/brands/${brandId}/search-console/authorize`, { returnPath }),

  callback: (body: { code?: string; state: string; error?: string }) =>
    api.post<{ result: GscCallbackResult; returnPath: string }>('/integrations/search-console/callback', body),

  setProperty: (brandId: string, siteUrl: string) =>
    api.put<GscStatus>(`/brands/${brandId}/search-console/property`, { siteUrl }),

  /** One `gsc_import` unit and two Google calls: the band caches the result (step 13 cost rule). */
  import: (brandId: string) => api.post<GscImportResponse>(`/brands/${brandId}/search-console/import`, {}),

  disconnect: (brandId: string) => api.delete<{ ok: true }>(`/brands/${brandId}/search-console`),
};
